import React from "react";
import ApplicationForm from "../applicationForm/ApplicationForm";
import CreditCheck from "../creditScoreCheck/CreditCheck";
import form_icon from "assets/images/application-form-icon.svg";
import close_icon from "assets/images/close_icon.svg";
import { Typography } from "@mui/material";
import styles from "./ApplyMortgage.module.css";
import Feedback from "component/feedback/Feedback";

function ApplyMortgage({
  saveAndQuit,
  setSaveAndQuit,
  application,
  formState,
  screen,
  setScreen,
  checkCredit,
  loadingCreditCheck,
  feedbackState,
  loading,
  setOpenApplicationForm,
  submit,
}) {
  switch (screen) {
    case "form":
      return (
        <div
          style={{
            width: "750px",
            height: "650px",
          }}
          className={styles.modal_layout}
        >
          <div className={styles.heading}>
            <Typography> Mortgage Application </Typography>
            <div className={styles.heading_right}>
              <div className={styles.heading_icon}>
                <img src={form_icon} alt="" />
              </div>
              <div
                onClick={() => {
                  setOpenApplicationForm(false);
                }}
                className={styles.close}
              >
                <img src={close_icon} alt="" />
              </div>
            </div>
          </div>
          <div className={styles.body}>
            {" "}
            <ApplicationForm
              saveAndQuit={saveAndQuit}
              setSaveAndQuit={setSaveAndQuit}
              application={application}
              formState={formState}
              handleCloseModal={() => {
                setOpenApplicationForm(false);
              }}
              submit={submit}
              loading={loading}
            />
          </div>
        </div>
      );

    case "credit-check":
      return (
        <CreditCheck
          setOpenApplicationForm={setOpenApplicationForm}
          onSubmit={checkCredit}
          loading={loadingCreditCheck}
        />
      );
    case "credit-check-success":
      return (
        <Feedback
          btnText={"Proceed to Application"}
          secondaryText="Credit Checked Successfully."
          feedbackState={feedbackState?.status}
          handleClickBtn={() => {
            setScreen("form");
          }}
        />
      );
    case "credit-check-failed":
      return (
        <Feedback
          btnText={"Close"}
          secondaryText={feedbackState?.message}
          feedbackState={feedbackState?.status}
          handleClickBtn={() => {
            setOpenApplicationForm(false);
          }}
        />
      );
    default:
      return (
        <CreditCheck
          setOpenApplicationForm={setOpenApplicationForm}
          onSubmit={checkCredit}
          loading={loadingCreditCheck}
        />
      );
  }
}

export default ApplyMortgage;
